import QuestionnaireForm from 'app/features/questionnaires/components/QuestionnaireForm';
import {
  selectPrepareQuestionnaire,
  update as updateprepareQuestionnaire,
} from 'app/features/questionnaires/create/PrepareQuestionnaire/slice';
import { useFields } from 'app/features/questionnaires/create/PrepareQuestionnaire/useFields';
import { useGetQuestionnaireByIdQueryState } from 'app/services/questionnaires';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { updateQuestionnaireRoutes } from '../../routes/slice';
import useSaveDraft from '../useSaveDraft';
import ConfirmSummary from './ConfirmSummary';
import PreviewSummary from './preview';

export default function Summary() {
  const initialState = useSelector(selectPrepareQuestionnaire);
  const dispatch = useDispatch();
  const { fields, validationSchema } = useFields();
  const { questionnaireId } = useParams();
  const { data: questionnaireData } = useGetQuestionnaireByIdQueryState(
    questionnaireId!,
  );

  const { saveDraft, isLoading, isSuccess } = useSaveDraft();

  const [readOnly, setReadOnly] = useState(true);

  const toggleReadOnly = () => setReadOnly((state) => !state);
  const onCancelConfig = () => {
    if (
      questionnaireData &&
      questionnaireData.questionnaire?.data?.prepareQuestionnaire
    ) {
      toggleReadOnly();

      dispatch(
        updateprepareQuestionnaire(
          questionnaireData.questionnaire.data.prepareQuestionnaire,
        ),
      );
      dispatch(
        updateQuestionnaireRoutes(
          questionnaireData.questionnaire?.data?.prepareQuestionnaire,
        ),
      );
    }
  };

  useEffect(() => {
    if (isSuccess) {
      toggleReadOnly();
    }
  }, [isSuccess]);

  return (
    <>
      <div className="flex justify-end p-3 text-green">
        {readOnly ? (
          <button onClick={toggleReadOnly}>Edit</button>
        ) : (
          <div className="flex gap-4">
            <button
              disabled={isLoading}
              className="text-gray-dark text-base"
              onClick={onCancelConfig}
            >
              Cancel
            </button>
            <button
              disabled={isLoading}
              className="text-base"
              onClick={saveDraft}
            >
              Save
            </button>
          </div>
        )}
      </div>

      {!readOnly ? (
        <div className="h-min">
          <QuestionnaireForm
            defautlValues={initialState}
            fields={fields}
            validationSchema={validationSchema}
            hideFooter
          />
        </div>
      ) : (
        <>
          <PreviewSummary />
          <ConfirmSummary />
        </>
      )}
    </>
  );
}
